import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { useCallback } from 'react';
import { createConfirmIncomeEventOutbound } from '../../api/outbound/commonOutbounds';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { thunkCloseCurrentMessageBox } from '../../redux/actions/messageBoxesActions';
import { useAppDispatch } from '../../redux/store';
export const IncomeEventMessageBoxContents = ({ incomeEventId }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClickConfirm = useCallback(() => {
        socketSend(createConfirmIncomeEventOutbound(incomeEventId));
        dispatch(thunkCloseCurrentMessageBox());
    }, [dispatch, incomeEventId, socketSend]);
    return (_jsx(DialogActions, { children: _jsx(Button, { onClick: () => onClickConfirm(), variant: 'contained', size: 'large', children: "Great!" }) }));
};
